module.exports = __webpack_public_path__ + "static/media/yelp.d3d0b4ac.png";